<template>
	<div id="selectzipaddr">
		<div class="selectZipAjaxBg">
			<div class="selectZipAjax">
				<ul class="list-group">
					<li v-for="(info,index) in listAddr" :key="index" class="list-group-item" @click.prevent="clickAddr(info)">
						{{info.address1+info.address2+info.address3}}
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		props: {
			listAddr: Array,
		},
		computed: {
		},
		methods: {
			clickAddr(addr) {
				this.$emit('select-addr', addr);
			},
		},
		mounted() {
		}
	};
</script>

<style lang="scss" scoped>
	#selectzipaddr {
		.selectZipAjaxBg {
			position: fixed;
			z-index: 99;
			display: flex;
			justify-content: center;
			align-items: center;
			left: 0;
			top: 0;
			width: 100vw;
			height: 100vh;
			background-color: rgba(0,0,0,0.5);
	
			.selectZipAjax {
				max-height: 100vh;
				padding: 16px;
				box-sizing: border-box;
				overflow: auto;
	
				ul {
					cursor: pointer;
					width: auto;
					display: inline-block;
	
					li {
						cursor: pointer;
						width: auto;
					}
	
				}
			}
		}
	}
</style>
